import React from "react";
import { ITenant } from "components/tenants/types";

interface CompanyInfoFormProps {
  formData: Partial<ITenant>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CompanyInfoForm: React.FC<CompanyInfoFormProps> = ({ formData, onChange }) => {
  return (
    <form>
      <div className="row">
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="name" className="form-label">
            Customer Name
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            placeholder="Enter Customer Name..."
            value={formData.companyInfo?.name || ""}
            onChange={onChange}
          />
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="address" className="form-label">
            Address
          </label>
          <input
            type="text"
            className="form-control"
            id="address"
            name="address"
            placeholder="Enter Adress..."
            value={formData.companyInfo?.address || ""}
            onChange={onChange}
          />
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="city" className="form-label">
            City
          </label>
          <input
            type="text"
            className="form-control"
            id="city"
            name="city"
            placeholder="Enter City..."
            value={formData.companyInfo?.city || ""}
            onChange={onChange}
          />
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="state" className="form-label">
            State
          </label>
          <input
            type="text"
            className="form-control"
            id="state"
            name="state"
            placeholder="Enter State..."
            value={formData.companyInfo?.state || ""}
            onChange={onChange}
          />
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="zip" className="form-label">
            ZIP
          </label>
          <input
            type="text"
            className="form-control"
            id="zip"
            name="zip"
            placeholder="Enter ZIP..."
            value={formData.companyInfo?.zip || ""}
            onChange={onChange}
          />
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="country" className="form-label">
            Country
          </label>
          <input
            type="text"
            className="form-control"
            id="country"
            name="country"
            placeholder="Enter Country..."
            value={formData.companyInfo?.country || ""}
            onChange={onChange}
          />
        </div>
      </div>
    </form>
  );
};

export default CompanyInfoForm;
